import language from "#scripts/translation";

export default (article) => {
	return `<article class="row article__main justify-content-md-center">
        <div class="col-md-11 col-lg-10">
            <h1 class="article__header">${article.title}</h1>
            ${
							article.intro.length > 2
								? `<div class="article__intro">${article.intro}</div>`
								: ""
						}
            ${
							article.created !== "" || article.published !== ""
								? `<span class="article__datetext article__datetext__date inline">
                    <span class="article__datetext__label article__datetext__date-created">${language(
											"ARTICLE_PUBLISHED",
										)} ${article.created}</span>
                    <span class="article__datetext__label article__datetext__date-published">${language(
											"ARTICLE_MODIFIED",
										)} ${article.published}</span>
        </span>`
								: ""
						}
            <div class='p-0'>${article.mainImage}</div>
        </div>
        <div class="article__content col-md-8 col-lg-7 p-md-0 ck-content">
            ${article.content}
        </div>
    </article>`;
};
